import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_EXTENTS } from './actions.type'
import { SET_EXTENTS, SET_EXTENTS_ERRORS, SET_EXTENTS_LOADING } from './mutations.type'

const state = {
	extents: [],
	extentsErrors: [],
	extentsIsLoading: false
}

const getters = {
	extents () {
		return state.extents
	},
	extentsErrors (state) {
		return state.extentsErrors
	},
	extentsIsLoading (state) {
		return state.extentsIsLoading
	}
}

const actions = {
	[FETCH_EXTENTS] (context, params) {
		context.commit(SET_EXTENTS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService
			.query('manager/extents')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_EXTENTS, data)
					resolve(data)
				} else {
					context.commit(SET_EXTENTS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_EXTENTS_ERRORS, context, error)
			})
		})
	}
}

const mutations = {
	[SET_EXTENTS] (state, data) {
		state.extents = data
		state.extentsErrors = []
		state.extentsIsLoading = false
	},
	[SET_EXTENTS_ERRORS] (state, errors) {
		state.extents = []
		state.extentsErrors = errors
		state.extentsIsLoading = false
	},
	[SET_EXTENTS_LOADING] (state) {
		state.extentsIsLoading = true
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/extents.module.js